import { useMemo } from "react";

import { IPart } from "../../../models/Part";
import openInNewTab from "../../../utils/openInNewTab";
import { ButtonInput } from "../../shared/Inputs/ButtonInput";
import { ebaySearchString } from "../../../utils/ebaySearchString";


export default function UnlistedEbaySearchButtons({ part }: { part: IPart }) {

  const makeModelString = useMemo(() => {
    let string = "";

    if (part.vehicle?.dvlaYearOfManufacture) {
      string = part.vehicle?.dvlaYearOfManufacture + "+";
    }

    string += part.vehicle?.combinedMake;
    string += "+";
    string += part.vehicle?.modelRangeDescription;

    if (part.category && part.category.name) {
      string += "+";
      string += part.category.name;
    }

    return string;
  }, [part])

  return (
    <div className="flex gap-x-4">
      {(part.vehicle?.combinedMake && part.vehicle?.modelRangeDescription) && (
        <ButtonInput
          onClick={() => openInNewTab(ebaySearchString(makeModelString))}
          classes={"bg-primary text-white hover:text-white hover:bg-primary-700 px-3 py-2"}
        >
          <span className="flex items-center gap-x-3">Search Make, Model, Year & Category <img src={`/ebayLogo.svg`} className="w-10 h-5" /> </span>
        </ButtonInput>
      )}

      {(part.partNumber || part.oePartNumber) && (
        <>
          {part.partNumber && (
            <ButtonInput
              onClick={() => openInNewTab(ebaySearchString(part.partNumber!))}
              classes={"bg-primary text-white hover:text-white hover:bg-primary-700 px-3 py-2"}
            >
              <span className="flex items-center gap-x-3">Search {part.partNumber} <img src={`/ebayLogo.svg`} className="w-10 h-5" /> </span>
            </ButtonInput>
          )}

          {(part.oePartNumber && part.oePartNumber !== part.partNumber) && (
            <ButtonInput
              onClick={() => openInNewTab(ebaySearchString(part.oePartNumber!))}
              classes={"bg-primary text-white hover:text-white hover:bg-primary-700 px-3 py-2"}
            >
              <span className="flex items-center gap-x-3">Search {part.oePartNumber} <img src={`/ebayLogo.svg`} className="w-10 h-5" /> </span>
            </ButtonInput>
          )}
        </>
      )}
    </div>
  )
}